// Pub/sub to bring brain chat to foreground temporarily
type Listener = (fg: boolean) => void;

let _foreground = false;
const _listeners = new Set<Listener>();

export function toggleBrainChatForeground() {
  _foreground = !_foreground;
  _listeners.forEach((fn) => fn(_foreground));
}

export function isBrainChatForeground() {
  return _foreground;
}

export function subscribeBrainChatForeground(fn: Listener): () => void {
  _listeners.add(fn);
  return () => _listeners.delete(fn);
}
